// A forecast trip → the plan lines Aurel would type for it (Director, 30 Oct:
// she could only reject the forecast's UJ suggestions, never take them, so
// taking one meant retyping it in Tambah). Names, tipe and customer follow
// her own October lines: "UJ Lampung 9507" (UJ Lampung · Indahkiat),
// "UJ Balikan Lapak LSJ 9952" (UJ Balikan · LSJ), "Koordinasi Konverta 9507"
// (Operasional · Other), "Terima Balikan Lapak LSJ 9952" (Penerimaan · LSJ).

// forecastModel.js RETURNS labels → her wording and customer
const RET = {
  'LSJ': { name: 'Lapak LSJ', customer: 'LSJ' },
  'Pak Aceng': { name: 'Lapak Pak Aceng', customer: 'Pak Aceng' },
  'Pak Ahmad': { name: 'Lapak Pak Ahmad', customer: 'Pak Ahmad' },
  // not a named buyer in the app (yet): his lines are customer Lapak, as Aurel's 23 Okt UJ was
  'Pak Dody': { name: 'Lapak Pak Dody', customer: 'Lapak' },
  'CSK → Aspex': { name: 'CSK Bogor', customer: 'CAN', csk: true },
  'CSK → Pindo': { name: 'CSK Karawang', customer: 'CAN', csk: true },
  'CSK → Serang': { name: 'CSK Serang', customer: 'CAN', csk: true },
};
const retOf = label => Object.keys(RET).find(k => label.includes(` ${k} `) || label.endsWith(` ${k}`) || label.includes(`Balikan ${k} `)) || null;

function lineOf(e) {
  const t = e.truck, amt = Math.abs(Math.round(e.amount));
  const base = { tanggal: e.date, no_truk: t, pengeluaran: e.amount < 0 ? amt : 0, penerimaan: e.amount > 0 ? amt : 0 };
  if (e.kind === 'pergi') return { ...base, keterangan: `UJ Lampung ${t}`, tipe: 'UJ Lampung', customer: 'Indahkiat' };
  if (e.kind === 'waste') return { ...base, keterangan: `UJ Waste Lampung ${t}`, tipe: 'UJ Waste Lampung', customer: 'Indahkiat' };
  const r = RET[retOf(e.label)];
  if (!r) return null;
  if (e.kind === 'ret') return { ...base, keterangan: `UJ Balikan ${r.name} ${t}`, tipe: 'UJ Balikan', customer: r.customer };
  // CAN pays by monthly invoice, not per trip: its receipt stays out (Piutang covers it)
  if (e.kind === 'recv' && !r.csk) return { ...base, keterangan: `Terima Balikan ${r.name} ${t}`, tipe: 'Penerimaan', customer: r.customer };
  return null;
}

// The lines for one trip: a lapak return brings its receipt along. Not the
// koordinasi: the forecast carries it as an expected share (≈105.263 =
// 200.000 × how often one is paid), not an amount anyone pays, so Aurel
// adds that line when it happens.
export function fcLinesFor(head, sameDay) {
  const along = head.kind === 'ret' ? sameDay.filter(x => x.truck === head.truck && x.kind === 'recv' && !x.dismissed) : [];
  return [head, ...along].map(lineOf).filter(Boolean);
}
